import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

/**
 * 将带 Layout 容器的层级路由树展开为扁平叶子路由列表。
 * 容器路由（有 children）替换为 redirect 占位路由，叶子路由直接收录。
 * 展开后的路由通过 router.addRoute('Root', route) 挂载为根 Layout 的子路由，
 * 确保所有页面共享同一 Layout 实例，keep-alive 缓存不会因 Layout 切换而失效。
 */
function extractFlatRoutes(routes, result = []) {
  routes.forEach(route => {
    if (route.children && route.children.length > 0) {
      if (route.redirect) {
        result.push({ path: route.path, redirect: route.redirect, hidden: true, meta: route.meta })
      }
      extractFlatRoutes(route.children, result)
    } else {
      result.push(route)
    }
  })
  return result
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      // 用「动态路由是否已挂载」作为判断依据，而非 userInfo。
      // 原因：login 接口已将 userInfo 写入 store，若改用 userInfo.id 判断，
      // 首次登录时会直接 next()，跳过 getInfo/generateRoutes，导致菜单不显示。
      const hasRoutes = store.state.permission.addRoutes && store.state.permission.addRoutes.length > 0
      if (hasRoutes) {
        next()
      } else {
        try {
          const data = await store.dispatch('user/getInfo')
          const accessRoutes = await store.dispatch('permission/generateRoutes', data.menus || [])
          // 将动态路由扁平化后挂载为根 Layout（'Root'）的子路由，
          // 与 constantRoutes 中的静态页面共享同一 Layout 实例。
          extractFlatRoutes(accessRoutes).forEach(route => router.addRoute('Root', route))
          // 等待 Vue 响应式更新完成后再导航，确保 v-permission 能正确读取 permissions
          await Vue.nextTick()
          // 直接导航到 /dashboard 避免 / -> /dashboard 重定向触发 NavigationRedirected 报错
          const targetPath = (to.path === '/' || to.path === '') ? '/dashboard' : to.path
          next({ path: targetPath, query: to.query, replace: true })
        } catch (error) {
          // request.js 已弹过错误提示；这里只负责清 token 并跳转登录
          await store.dispatch('user/resetToken')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to) => {
  NProgress.done()
  // 在 Vue DOM 更新队列刷新之前将路由 name 写入 cachedViews，
  // 确保 keep-alive 第一次渲染该组件时 include 列表已包含其 name，
  // 避免因时序问题导致组件未被缓存、每次导航回来都重新创建。
  if (to.name && !to.meta?.noCache) {
    store.dispatch('tagsView/addCachedView', to)
  }
})
